import { isEmpty } from 'lodash';
import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

const list = (state: any = initialState.orders.list, action: any) => {
  switch (action.type) {
    case State.actionRequested(Type.GET_ORDERS):
      return requestedDefaults(state, action);
    case State.actionSucceeded(Type.GET_ORDERS):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_ORDERS):
      return failedDefaults(state, action);
    case State.actionCleared(Type.GET_ORDERS):
      return clearedDefaults(state);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.list;
    default:
      return state;
  }
};

const cumulativeList = (state: any = initialState.orders.cumulativeList, action: any) => {
  switch (action.type) {
    case State.actionRequested(Type.GET_CUMULATIVE_ORDER_LIST):
      return requestedDefaults(state, action);
    case State.actionSucceeded(Type.GET_CUMULATIVE_ORDER_LIST):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_CUMULATIVE_ORDER_LIST):
      return failedDefaults(state, action);
    case State.actionCleared(Type.GET_CUMULATIVE_ORDER_LIST):
      return clearedDefaults(state);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.cumulativeList;
    default:
      return state;
  }
};

const details = (state: any = initialState.orders.details, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_ORDERS_ID):
      return {
        ...state,
        [action.payload.id]: {
          isLoading: false,
          __succeeded: null,
          __failed: null,
          data: null,
          _isFetched: false,
          error: null,
        },
      };
    case State.actionRequested(Type.GET_ORDERS_ID):
      return {
        ...state,
        [action.payload.params.id]: {
          isLoading: true,
          __succeeded: null,
          __failed: null,
          data: isEmpty(state[action.payload.params.id]?.data)
            ? undefined
            : { ...state[action.payload.params.id]?.data, ...action?.payload },
          _isFetched: true,
          error: null,
        },
      };
    case State.actionSucceeded(Type.GET_ORDERS_ID):
      return {
        ...state,
        [action.payload.id]: {
          isLoading: false,
          __succeeded: new Date(),
          __failed: null,
          data: { ...state[action.payload.id]?.data, ...action.payload },
          _isFetched: true,
          error: null,
        },
      };
    case State.actionFailed(Type.GET_ORDERS_ID):
      return {
        ...state,
        [action.payload.id]: {
          isLoading: false,
          __succeeded: null,
          __failed: new Date(),
          data: isEmpty(state[action.payload.id]?.data) ? undefined : { ...state[action.payload.id]?.data },
          _isFetched: true,
          error: action.payload,
        },
      };
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.details;
    default:
      return state;
  }
};

const create = (state: any = initialState.orders.create, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.CREATE_ORDER):
      return clearedDefaults(state);
    case State.actionRequested(Type.CREATE_ORDER):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CREATE_ORDER):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CREATE_ORDER):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.create;
    default:
      return state;
  }
};

const cancel = (state: any = initialState.orders.cancel, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.CANCEL_ORDER):
      return clearedDefaults(state);
    case State.actionRequested(Type.CANCEL_ORDER):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CANCEL_ORDER):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CANCEL_ORDER):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.orders.cancel;
    default:
      return state;
  }
};

export const orderReducers = combineReducers({
  list,
  cumulativeList,
  details,
  create,
  cancel,
});
